module.exports = __webpack_public_path__ + "img/1.01ee78f7.png";